/* eslint-disable no-use-before-define, no-confusing-arrow */
const wcag = () => {
  const wcagButtons = document.querySelectorAll('[data-wcag]');

  if (!wcagButtons.length) {
    return;
  }

  let baseFontSize = 62.5;
  const maxFontSize = 82.5;
  const html = document.querySelector('html');
  const pageBody = document.querySelector('body');

  const fontSizeStorage = 'font-size-set';
  const contrastStorage = 'contrast-set';

  const fontStorageValueSet = localStorage.getItem(fontSizeStorage);
  const contrastStorageSet = localStorage.getItem(contrastStorage);

  const restrict = (val, min, max) => Math.min(Math.max(val, min), max);

  const checkForStorageAndApply = () => {
    if (fontStorageValueSet) {
      changeFontSize(0);
    }

    if (contrastStorageSet) {
      toggleContrast();
    }
  };

  const validateIfNotExcedeed = (fontSize) => fontSize >= maxFontSize ? baseFontSize : fontSize;

  const changeFontSize = (value) => {
    if (fontStorageValueSet) {
      let fontSize = +localStorage.getItem(fontSizeStorage);
      fontSize = restrict(fontSize + value, baseFontSize, maxFontSize);
      fontSize = validateIfNotExcedeed(fontSize);
      setFontSizeStorage(fontSize);
      html.style.fontSize = `${fontSize}%`;
    } else {
      baseFontSize = restrict(baseFontSize + value, baseFontSize, maxFontSize);
      baseFontSize = validateIfNotExcedeed(baseFontSize);
      html.style.fontSize = `${baseFontSize}%`;
      setFontSizeStorage(baseFontSize);
    }
  };

  const toggleContrast = () => {
    const contrastClass = 'contrast';
    const bodyHasClass = pageBody.classList.contains(contrastClass);

    if (bodyHasClass) {
      pageBody.classList.remove(contrastClass);
      localStorage.removeItem(contrastStorage);
    } else {
      pageBody.classList.add(contrastClass);
      localStorage.setItem(contrastStorage, 1);
    }
  };

  const setFontSizeStorage = (fontSize) => {
    if (fontStorageValueSet) {
      localStorage.removeItem(fontSizeStorage);
    }
    localStorage.setItem(fontSizeStorage, fontSize);
  };

  checkForStorageAndApply();

  Array.from(wcagButtons).forEach((btn) => {
    btn.addEventListener('click', () => {
      const wcagType = btn.dataset.wcag;

      switch (wcagType) {
        case 'contrast':
          toggleContrast();
          break;
        case 'font-increase':
          changeFontSize(5);
          break;
        default:
          break;
      }
    });
  });
};

export default wcag;
